<template>
    <o-form :title="$t('core.report_access')"
            :url="'/api/system/report_access/' + $route.params.id"
            class="ortic-form-horizontal">
        <template slot-scope="props">
        <b-row>
          <b-col>
            <o-value-select v-model="props.item.report_id" :items="reports" :label="$t('core.report')"
                :title="$t('core.report')"/>
            <o-value-select v-model="props.item.role_id" :items="roles" :label="$t('core.role')"
                :title="$t('core.role')"/>    
          </b-col>
          <b-col>
          </b-col>
        </b-row>
      </template>
    </o-form>
  </template>


<script>
  import axios from 'axios'
  export default {
    data: () => ({
      reports: [],
      roles: []
    }),
    mounted() {
      this.getReports()
      this.getRoles()
    },
    methods: {
			getRoles() {
				var self = this
        axios.get(`/api/system/roles?per_page=999&sortBy=name`).then(response => {
					if (response.data.data.length) {
						console.log("response.data", response.data)
						response.data.data.forEach(function (role) {
								self.roles.push({ value: role.id, text: role.name })
						})
					}
        })
      },
      getReports () {
				var self = this
        axios.get(`/api/sandoz/reports?per_page=999&sortBy=name`).then(response => {
          if (response.data.data.length) {
						response.data.data.forEach(function (report) {
								self.reports.push({ value: report.id, text: report.name })
						})
					}
        })
      }
    }
  }
</script>

